"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _immer = _interopRequireDefault(require("immer"));
var _Button = _interopRequireDefault(require("@mui/material/Button/Button.js"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _ = require(".");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _makeStyles.default)(({
  spacing
}) => ({
  addBtn: {
    marginTop: spacing(1)
  }
}));
var _default = ({
  className,
  rows,
  rowSchema,
  component: Component,
  onChange,
  onAddAll,
  ...rest
}) => {
  const classes = useStyles({});
  const handleAdd = () => onChange([...rows, {
    ...rowSchema,
    id: (rows.length + 1).toString()
  }]);
  const handleRemove = row => onChange(rows.filter(r => r.id !== row.id));
  const handleChange = row => onChange((0, _immer.default)(rows, draft => {
    draft.splice(draft.findIndex(r => r.id === row.id), 1, row);
  }));
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: className,
    children: [rows && rows.map((row, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, {
      data: row,
      index: i,
      onRemove: handleRemove,
      onChange: handleChange,
      ...rest
    }, row.id)), onAddAll ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_.SplitButton, {
      buttonGroupProps: {
        color: 'primary',
        className: classes.addBtn
      },
      options: [{
        label: 'Add Row',
        onClick: handleAdd
      }, {
        label: 'Add Row for each Column',
        onClick: onAddAll
      }]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
      className: classes.addBtn,
      variant: "outlined",
      onClick: handleAdd,
      children: "Add Row"
    })]
  });
};
exports.default = _default;